import * as React from 'react';
import { CONSTANTS } from '../../assets/UIConstants';
import * as Popover from 'react-awesome-popover';

interface Props {
    title?: string;
    iconColor?: string;
    iconBorderColor?: string;
    icon?: React.ComponentClass<{color?: string}>;
    popoverTitle?: string;
    popoverBody?: string | JSX.Element;
}

interface State {
    open: boolean;
    target?: HTMLElement | undefined;
}

export class PanelTitle extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);
        this.state = {
            open: false,
        };
    }

    private style: React.CSSProperties = {
        container: {
            display: 'flex',
            height: 80,
            justifyContent: CONSTANTS.FLEX_JUSTIFY.SPACE_BETWEEN,
            alignItems: CONSTANTS.ALIGN_ITEMS.CENTER,
            paddingLeft: 28, 
            paddingRight: 35,
        },
        title: {
            textTransform: 'uppercase'
        },
        icon: {
            display: CONSTANTS.DISPLAY.FLEX,
            alignItems: CONSTANTS.ALIGN_ITEMS.CENTER,
            justifyContent: CONSTANTS.FLEX_JUSTIFY.CENTER,
            border: '1px solid ' + (this.props.iconBorderColor || CONSTANTS.COLORS.BUTTON_OUTLINE_GREY),
            borderRadius: '50%',
            height: 35,
            width: 35,
        },
        popoverStyle: {
            padding: 25 + 'px',
            border: '2px solid ' + CONSTANTS.COLORS.BORDER_GREY,
            borderRadius: 20 + 'px',
            backgroundColor: 'white',
            margin: -2 + 'px',
            color: 'black'
        }
    };

    private togglePopover(e: React.MouseEvent<HTMLDivElement>): void {
        this.setState({
            open: !this.state.open,
            target: e.currentTarget,
        });
    }

    private renderPopover(): React.ReactNode {
        if (this.props.icon && (this.props.popoverTitle || this.props.popoverBody)) {
            return (
                <Popover
                    open={this.state.open}
                    style={{zIndex: 999}}
                    className={'nl_popover'}
                    // this class applies some css rules we aren't able to add in-line
                >
                    <div
                        style={this.style.icon}
                        onClick={(e) => this.togglePopover(e)}
                    >
                        <div style={{height: 16}}>
                            <this.props.icon
                                color={this.props.iconColor}
                            />
                        </div>
                    </div>
                    <div style={this.style.popoverStyle}>
                        <div>
                            {this.props.popoverTitle}
                        </div>
                        <div>
                            {this.props.popoverBody}
                        </div>
                    </div>
                </Popover>
            );
        }
        return null;
    }

    public render(): JSX.Element {
        return (
            <div style={this.style.container}>
                <div style={this.style.title}>
                    {this.props.title}
                </div>
                {this.renderPopover()}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/PanelTitle.tsx